import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled, { css } from '../../theming/styled-components.js';
import React, { memo, forwardRef } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import useLegacyProps from '../../hooks/useLegacyProps.js';

var _excluded = ["buttonType", "children", "disabled", "size"];
var _templateObject;
//check secureSiteTheme.ts for more styling 
var LfgStyledButton = styled('button')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 1rem;\n  font-family: inherit;\n  padding: 0 2rem;\n  line-height: 1.2;\n\n  cursor: pointer;\n  color: ", ";\n  font-weight: 400;\n  background-color: ", ";\n  border: ", ";\n\n  outline: 0;\n  height: 42px;\n  max-height: 42px;\n  white-space: nowrap;\n  & + & {\n    margin-left: 1rem;\n  }\n\n  &:active:enabled,\n  &:hover:enabled,\n  &:focus:enabled {\n    ", ";\n    text-decoration: ", ";\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    color: ", ";\n    background-color: ", ";\n    border: ", ";\n    box-shadow: none;\n  }\n"])), function (_ref) {
  var theme = _ref.theme,
    _ref$buttonType = _ref.buttonType,
    buttonType = _ref$buttonType === void 0 ? 'text' : _ref$buttonType;
  return theme.button[buttonType].txtColor;
}, function (_ref2) {
  var theme = _ref2.theme,
    _ref2$buttonType = _ref2.buttonType,
    buttonType = _ref2$buttonType === void 0 ? 'text' : _ref2$buttonType;
  return theme.button[buttonType].bgColor;
}, function (_ref3) {
  var theme = _ref3.theme,
    _ref3$buttonType = _ref3.buttonType,
    buttonType = _ref3$buttonType === void 0 ? 'text' : _ref3$buttonType;
  return theme.button[buttonType].border;
}, function (_ref4) {
  var theme = _ref4.theme,
    _ref4$buttonType = _ref4.buttonType,
    buttonType = _ref4$buttonType === void 0 ? 'text' : _ref4$buttonType;
  return css(theme.button[buttonType].actionStyle);
}, function (_ref5) {
  var _ref5$buttonType = _ref5.buttonType,
    buttonType = _ref5$buttonType === void 0 ? 'text' : _ref5$buttonType;
  return buttonType === 'text' ? 'underline' : null;
}, function (_ref6) {
  var theme = _ref6.theme,
    _ref6$buttonType = _ref6.buttonType,
    buttonType = _ref6$buttonType === void 0 ? 'text' : _ref6$buttonType;
  return theme.button[buttonType].disabled.txtColor;
}, function (_ref7) {
  var theme = _ref7.theme,
    _ref7$buttonType = _ref7.buttonType,
    buttonType = _ref7$buttonType === void 0 ? 'text' : _ref7$buttonType;
  return theme.button[buttonType].disabled.bgColor;
}, function (_ref8) {
  var theme = _ref8.theme,
    _ref8$buttonType = _ref8.buttonType,
    buttonType = _ref8$buttonType === void 0 ? 'text' : _ref8$buttonType;
  return "1px solid ".concat(theme.button[buttonType].disabled.borderColor);
});
var Button = function Button(_ref9, ref) {
  var _ref9$buttonType = _ref9.buttonType,
    buttonType = _ref9$buttonType === void 0 ? 'text' : _ref9$buttonType,
    children = _ref9.children,
    disabled = _ref9.disabled,
    _ref9$size = _ref9.size,
    size = _ref9$size === void 0 ? 'medium' : _ref9$size,
    rest = _objectWithoutProperties(_ref9, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  // TODO - Need to deprecate the "default" styles, as LFG
  // does not have something similar.
  var derivedButtonType = buttonType === 'default' ? 'text' : buttonType;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LfgStyledButton, _extends({}, rest, {
    className: className,
    style: style,
    buttonType: derivedButtonType,
    disabled: disabled,
    size: size,
    ref: ref
  }), children));
};
var _Button = withDefaultTheme(/*#__PURE__*/memo(/*#__PURE__*/forwardRef(Button)));

export default _Button;
